import RegisterService from '../register-service';
import Service from '@/service/index.js';

// 注册
const registerUser = ({}, params) => {
  return new Promise((resolve, reject) => {
    RegisterService.registerUser(params).then(response => {
      resolve(response);
    }, error => {
      reject(error.data);
    });
  });
};

// 获取字典列表
const getSelectDictList = ({}, dicTid) => {
  return new Promise((resolve, reject) => {
    Service.getSelectList(dicTid).then(response => {
      resolve(response);
    }, error => {
      reject(error.data);
    });
  });
};

// 根据银行卡查询开户银行
const getBankAddressByCard = ({}, bankCard) => {
  return new Promise((resolve, reject) => {
    Service.getBankAddressByCard(bankCard).then(response => {
      resolve(response);
    }, error => {
      reject(error.data);
    });
  });
};

// 根据银行卡查询连行号
const getCorrespondCodeByCardNo = ({}, bankCard) => {
  return new Promise((resolve, reject) => {
    Service.getCorrespondCodeByCardNo(bankCard).then(response => {
      resolve(response);
    }, error => {
      reject(error.data);
    });
  });
};

export const actions = {
  getSelectDictList,
  registerUser,
  getBankAddressByCard,
  getCorrespondCodeByCardNo
};
